import * as goldenrush from './JoinNow.styles.goldenrush';
import * as juicybet from './JoinNow.styles.juicybet';
import * as puntcity from './JoinNow.styles.puntcity';
import * as sterlingparker from './JoinNow.styles.sterlingparker';
import * as vikingbet from './JoinNow.styles.vikingbet';
import * as forsport from './JoinNow.styles.forsport';
import * as junglebet from './JoinNow.styles.junglebet';
import * as oldgill from './JoinNow.styles.oldgill';
import * as sugarcastle from './JoinNow.styles.sugarcastle';
import * as buffalobet from './JoinNow.styles.buffalobet';
import * as titanbet from './JoinNow.styles.titanbet';
import * as bet777 from './JoinNow.styles.bet777';
import * as gigabet from './JoinNow.styles.gigabet';
import * as slambet from './JoinNow.styles.slambet';
import * as betstride from './JoinNow.styles.betstride';
import * as templebet from './JoinNow.styles.templebet';
import * as goldenbet888 from './JoinNow.styles.goldenbet888';
import * as hyperbet from './JoinNow.styles.hyperbet';
import * as chromabet from './JoinNow.styles.chromabet';
import * as bet575 from './JoinNow.styles.bet575';
import * as epicodds from './JoinNow.styles.epicodds';
import * as pyramidbet from './JoinNow.styles.pyramidbet';
import * as magnumbet from './JoinNow.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  goldenrush,
  juicybet,
  puntcity,
  sterlingparker,
  vikingbet,
  forsport,
  junglebet,
  oldgill,
  sugarcastle,
  buffalobet,
  titanbet,
  bet777,
  gigabet,
  slambet,
  betstride,
  templebet,
  goldenbet888,
  hyperbet,
  chromabet,
  bet575,
  epicodds,
  pyramidbet,
  magnumbet,
};
